module.exports = __webpack_public_path__ + "assets/e1bb71250a14f6f610b1250d3a4319d4.mp3";